// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tZ__x","title":"styles_title__2DqLO"};